import { render } from "./profit_jyutyuinput.vue?vue&type=template&id=47de62d9&scoped=true&ts=true"
import script from "./profit_jyutyuinput.vue?vue&type=script&lang=ts"
export * from "./profit_jyutyuinput.vue?vue&type=script&lang=ts"

import "./profit_jyutyuinput.vue?vue&type=style&index=0&id=47de62d9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47de62d9"]])

export default __exports__